export default "__VITE_ASSET__b253b90d__"